export { Faq } from './Faq';
